module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-LightItalic.c8c382f2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-LightItalic.eot
// module id = 934
// module chunks = 0